import { NgModule } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { SiModalModule } from '../si-modal';
import { CommonModule } from '@angular/common';
import { MultiSelectorFormFieldModule } from '../ui-components';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IsFeatureFlagEnabledPipeModule } from '../../pipes';

@NgModule({
    imports: [
        DisableAutocompleteDirectiveModule,
        MatInputModule,
        FormsModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatButtonModule,
        SiModalModule,
        CommonModule,
        MultiSelectorFormFieldModule,
        MatCheckboxModule,
        MatTooltipModule,
        IsFeatureFlagEnabledPipeModule,
    ]
})
export class SaveSearchModule { }
